<template>
  <span>
    <div
      @click="displayTable((showTable = !showTable))"
      class="xm-select tableSelectInput"
      size="small"
      style="border-color: #eee;"
    >
      <i class="xm-icon xm-icon-expand"></i>
      <!-- <div class="xm-label single-row"> -->
      <div class="xm-tips">{{ tip }}</div>
      <div class="xm-label auto-row">
        <div class="scroll">
          <div class="label-content">
            <div
              class="xm-label-block"
              v-for="row in checkedRows"
              v-bind:key="row[valueField]"
              style="background-color: #F1F6FF;border:1px solid #cccccc ; border-radius:8px;height: auto"
            >
              <span
                v-html="renderText(row, textField)"
                :style="{ 'max-width': textWidth }"
                style="display: inline-block;overflow: hidden;"
              >
              </span>
              <!--                                    <i v-if="!multiTableList || multiTableList.length === 0" class="xm-iconfont xm-icon-close" @click.stop="checkedRows.remove(row); tableRef.checkRow(row)"></i>-->
              <i
                v-if="!multiTableList || multiTableList.length === 0"
                class="xm-iconfont xm-icon-close"
                @click="removeRow(row)"
              ></i>
              <!--                                    <i v-if="removeType === 'multi-remove'" class="xm-iconfont xm-icon-close" @click="removeRows(row)"></i>-->
              <i v-else class="xm-iconfont xm-icon-close" @click="removeRows(row)"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="tableSelect layui-anim layui-anim-upbit tableSelectTable"
      style="display:none;border: 1px solid #d2d2d2;background-color: #fff;box-shadow: 0 2px 4px rgba(0,0,0,.12);padding:10px 10px 10px 10px;position: absolute;
                        z-index:66666666;margin: 5px 0;border-radius: 2px;"
    >
      <div class="tableSelectBar" style="margin-bottom:10px">
        <input
          v-model="inputSearch"
          style="display:inline-block;width:190px;height:30px;vertical-align:middle;margin-right:-1px;border: 1px solid #C9C9C9;"
          type="text"
          placeholder="请输入关键字搜索"
          autocomplete="off"
          class="layui-input"
        />
        <button
          title="查询"
          @click.stop="search()"
          style="margin-left: 10px;"
          class="layui-btn layui-btn-sm layui-btn-primary "
        >
          <i class="layui-icon layui-icon-search" style="color:white;"></i>
        </button>
        <button title="重置" @click.stop="reset()" class="layui-btn layui-btn-sm layui-btn-primary">
          <i class="layui-icon layui-icon-refresh-1" style="color:white"></i>
        </button>
      </div>
      <layui-table
        ref="tableRef"
        :table-name="tableName"
        :view-name="viewName"
        :page-size="pageSize"
        :page-range="pageRange"
        :page-options="pageOptions"
        :default-condition="defaultCondition"
        :select-fields="selectFields"
        :un-selectFields="unSelectFields"
        :renderDone="renderDone"
        :beforeLoad="beforeLoad"
        :afterLoad="handleAfterLoad"
        :lazy="true"
        :sort="sort"
        :showToPage="false"
        :showPage="tableRef.pageInfo.totalNum > pageSize"
        @check="handleCheck()"
        height="400"
      >
        <slot></slot>
      </layui-table>
    </div>
  </span>
</template>

<script>
export default {
  name: 'LayuiTableSelect',
  props: {
    tip: {
      default: '请选择',
      type: String
    },
    placeholder: {
      default: '',
      type: String
    },
    _model: {
      default: '',
      required: false
    },
    enabled: {
      type: Boolean,
      default: () => {
        return true
      }
    },
    queryFields: {
      type: String
    },
    // 表名
    tableName: {
      type: String,
      default: '',
      required: true
    },
    // 视图名
    viewName: {
      type: String,
      default: ''
    },
    lazy: {
      type: Boolean,
      default: false
    },
    beRelated: {
      type: Boolean,
      default: false
    },
    slaveTables: {
      type: Array,
      default: () => {
        return []
      }
    },
    multiTableList: {
      type: Array,
      default: () => {
        return []
      }
    },
    fieldFilter: {
      type: String,
      default: ''
    },
    removeType: {
      type: String,
      default: ''
    },
    sort: {
      type: Array,
      default: () => {
        return []
      }
    },
    //line （行边框风格）row （列边框风格）nob （无边框风格）默认无
    skin: {
      type: String,
      default: ''
    },
    height: {
      type: String,
      default: 'full-220'
    },
    tableWidth: {
      type: String,
      default: '400px'
    },
    inputWidth: {
      type: String,
      default: '190px'
    },
    textWidth: {
      type: String,
      default: '140px'
    },
    //开启合计行，默认不开启
    totalRow: {
      type: Boolean,
      default: false
    },
    // 默认查询条件，比如state=1， 那么table加载的时候会查询state=1的数据
    // 如果在其他地方设置了关于state的值，那么默认值失效
    defaultCondition: {
      type: Object,
      default: () => {
        return {}
      }
    },
    // 要查询的字段，默认查询所有
    selectFields: {
      type: String,
      default: ''
    },
    // 如果配置了selectFields,该属性失效
    unSelectFields: {
      type: String,
      default: ''
    },
    pageSize: {
      type: Number
    },
    pageRange: {
      type: Number
    },
    pageOptions: {
      type: Array,
      default: () => {
        return []
      }
    },
    tableEventPrefix: {
      type: String,
      default: 'table-event-'
    },
    renderRow: {
      type: Function
    },
    // 是否显示分页组件
    showPage: {
      type: Boolean,
      default: () => {
        return true
      }
    },
    renderDone: {
      type: Function
    },
    beforeLoad: {
      type: Function,
      default: () => {}
    },
    textField: {
      default: 'text',
      type: String
    },
    valueField: {
      default: 'value',
      type: String
    },
    renderText: {
      type: Function,
      default: (row, textField) => {
        return row[textField]
      }
    }
  },
  model: {
    prop: '_model',
    event: '_modelEvent'
  },
  data: function() {
    return {
      inputSearch: '',
      showTable: false,
      tableRef: {
        pageInfo: {},
        checkedRows: []
      },
      checkedRows: []
    }
  },
  mounted() {
    var that = this
    this.tableRef = this.$refs.tableRef
    var id = (this.id = 'layuiTableSelect' + this.uuid())
    var element = (this.el = $(this.$el))
    this.tableSelectInput = element.find('.tableSelectInput')
    this.tableSelectTable = element.find('.tableSelectTable')
    this.tableSelectInput.css('width', this.inputWidth)
    this.tableSelectTable.css('width', this.tableWidth)
    var offset = this.offSet(this.tableSelectInput)
    var top = offset.top + 'px'
    var left = offset.left + 'px'
    this.tableSelectTable.css('left', left).css('top', top)
    this.isloaded = false
    this.tableRef.load()
    //点击其他区域关闭
    $(document).mouseup(function(e) {
      var userSet_con = that.el.find('.tableSelectInput,.tableSelect')
      if (!userSet_con.is(e.target) && userSet_con.has(e.target).length === 0) {
        that.displayTable(false)
      }
    })
  },
  methods: {
    handleCheck() {
      if (this.multiTableList && this.multiTableList.length > 0) {
        this.checkedRows = [...this.tableRef.checkedRows, ...this.multiTableList]
      } else {
        this.checkedRows = [...this.tableRef.checkedRows]
      }

      var value = []
      for (var i = 0; i < this.checkedRows.length; i++) {
        value.push(this.checkedRows[i][this.valueField])
      }

      if (this.removeType !== 'multi-remove') {
        this.$emit('_modelEvent', value.join(','))
      }

      // this.$emit('_modelEvent', value.join(','));
      this.$emit('selectChange', this.checkedRows)
      //关闭弹窗
      this.displayTable(false)
    },
    removeRow(row) {
      this.checkedRows.remove(row)
      this.tableRef.checkRow(row)

      if (this.removeType === 'multi-remove') {
        this.$emit('selectChange', row)
        this.displayTable(true)
      }
    },
    removeRows(row) {
      for (let i = 0; i < this.checkedRows.length; i++) {
        let item = this.checkedRows[i]
        if (item[this.fieldFilter] === row[this.fieldFilter]) {
          this.checkedRows.splice(i, 1)
        }
      }

      this.$emit('selectChange', this.checkedRows)
      this.displayTable(true)
    },
    displayTable(showTable) {
      this.showTable = showTable
      let tableEl = this.el.find('.tableSelect')
      this.showTable ? tableEl.show() : tableEl.hide()
      this.el.find('.layui-form.layui-border-box.layui-table-view').css('padding', '0px')
    },
    offSet(curEle) {
      var totalLeft = null
      var totalTop = null
      var par = curEle.offsetParent
      //首先把自己本身的相加
      totalLeft += curEle.offsetLeft
      totalTop += curEle.offsetTop
      //现在开始一级一级往上查找，只要没有遇到body，我们就把父级参照物的边框和偏移相加
      while (par) {
        if (navigator.userAgent.indexOf('MSIE 8.0') === -1) {
          //不是IE8我们才进行累加父级参照物的边框
          totalTop += par.clientTop
          totalLeft += par.clientLeft
        }
        //把父级参照物的偏移相加
        totalTop += par.offsetTop
        totalLeft += par.offsetLeft
        par = par.offsetParent
      }
      return { left: totalLeft, top: totalTop }
      //返回一个数组，方便我们使用哦。
    },
    search() {
      this.isloaded = false
      if (this.queryFields && this.inputSearch) {
        var arr = []
        var fields = this.queryFields.split(',')
        fields.forEach(field => {
          arr.push(field + ':2')
        })
        this.tableRef.queryObject = {}
        this.tableRef.queryObject[arr.join(',')] = this.inputSearch
      }
      this.tableRef.search()
    },
    reset() {
      this.isloaded = false
      this.inputSearch = ''

      if (this.beRelated) {
        if (this.queryFields && this.inputSearch) {
          var arr = []
          var fields = this.queryFields.split(',')
          fields.forEach(field => {
            arr.push(field + ':2')
          })
          this.tableRef.queryObject = {}
          this.tableRef.queryObject[arr.join(',')] = this.inputSearch
        }
        this.tableRef.search()
      } else {
        this.tableRef.reset()
      }
    },
    update() {
      if (this.modelChange) {
        this.modelChange = false
        var modelStr = this._model + ''
        var arr = modelStr ? modelStr.split(',') : []

        var p2 = {}
        p2[this.valueField + ':1'] = arr.join()

        this.api.queryList(this.tableName, { p2: p2 }, this.requestUniqueId).then(response => {
          var result = response.result
          if (result) {
            result.forEach(e => {
              for (var i = 0; i < arr.length; i++) {
                if (e[this.valueField] == arr[i]) {
                  var flag = true
                  for (var j = 0; j < this.checkedRows.length; j++) {
                    if (this.checkedRows[j][this.valueField] == arr[i]) {
                      flag = false
                      break
                    }
                  }
                  if (flag) {
                    this.tableRef.checkRow(e)
                    this.checkedRows.push(e)
                  }
                }
              }
            })
          }

          this.$emit('modelChange', this.checkedRows)
        })
      }
    },
    handleAfterLoad() {
      this.isloaded = true
      this.el.find('.layui-form.layui-border-box.layui-table-view').css('padding', '0px')
      if (this.modelChange) {
        this.update()
        return
      }
      //主要处理table刷新后，如果model有值，那么对应的记录应该选中
      var modelStr = this._model + ''
      var arr = modelStr ? modelStr.split(',') : []

      var p2 = {}
      p2[this.valueField + ':1'] = arr.join()

      this.api.queryList(this.tableName, { p2: p2 }, this.requestUniqueId).then(response => {
        var result = response.result
        if (result) {
          result.forEach(e => {
            for (var i = 0; i < arr.length; i++) {
              if (e[this.valueField] === arr[i]) {
                for (var j = 0; j < this.checkedRows.length; j++) {
                  if (this.checkedRows[j][this.valueField] == arr[i]) {
                    this.tableRef.checkRow(e)
                    break
                  }
                }
              }
            }
          })
        }
      })
    }
  },
  watch: {
    _model(value) {
      this.modelChange = true
      if (this.isloaded) {
        this.update()
      }
    }
  }
}
</script>
<style scoped>
@-webkit-keyframes xm-upbit {
  from {
    -webkit-transform: translate3d(0, 30px, 0);
    opacity: 0.3;
  }
  to {
    -webkit-transform: translate3d(0, 0, 0);
    opacity: 1;
  }
}
@keyframes xm-upbit {
  from {
    transform: translate3d(0, 30px, 0);
    opacity: 0.3;
  }
  to {
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }
}
@-webkit-keyframes loader {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes loader {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
.xm-select {
  background-color: #fff;
  position: relative;
  border: 1px solid #e6e6e6;
  border-radius: 2px;
  display: block;
  width: 100%;
  cursor: pointer;
  outline: none;
}

.xm-select * {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-size: 14px;
  font-weight: 400;
  text-overflow: ellipsis;
  user-select: none;
  -ms-user-select: none;
  -moz-user-select: none;
  -webkit-user-select: none;
}
.xm-select:hover {
  border-color: #c0c4cc;
}
.xm-select > .xm-tips {
  color: #999999;
  padding: 0 10px;
  position: absolute;
  display: flex;
  height: 100%;
  align-items: center;
}
.xm-select > .xm-icon {
  display: inline-block;
  overflow: hidden;
  position: absolute;
  width: 0;
  height: 0;
  right: 10px;
  top: 50%;
  margin-top: -3px;
  cursor: pointer;
  border: 6px dashed transparent;
  border-top-color: #c2c2c2;
  border-top-style: solid;
  transition: all 0.3s;
  -webkit-transition: all 0.3s;
}
.xm-select > .xm-icon-expand {
  margin-top: -9px;
  transform: rotate(180deg);
}
.xm-select > .xm-label.single-row {
  position: absolute;
  top: 0;
  bottom: 0px;
  left: 0px;
  right: 30px;
  overflow: auto hidden;
}
.xm-select > .xm-label.single-row .scroll {
  overflow-y: hidden;
}
.xm-select > .xm-label.single-row .label-content {
  flex-wrap: nowrap;
  white-space: nowrap;
}
.xm-select > .xm-label.auto-row .label-content {
  flex-wrap: wrap;
  padding-right: 30px !important;
}
.xm-select > .xm-label.auto-row .xm-label-block > span {
  white-space: unset;
  height: 100%;
}
.xm-select > .xm-label .scroll .label-content {
  display: flex;
  padding: 3px 10px;
}
.xm-select > .xm-label .xm-label-block {
  display: flex;
  position: relative;
  padding: 0px 5px;
  margin: 2px 5px 2px 0;
  border-radius: 3px;
  align-items: baseline;
  color: #fff;
}
.xm-select > .xm-label .xm-label-block > span {
  display: flex;
  color: #4d4d4d;
  white-space: nowrap;
}
.xm-select > .xm-label .xm-label-block > i {
  color: blue;
  margin-left: 8px;
  font-size: 12px;
  cursor: pointer;
  display: flex;
}
.xm-select > .xm-label .xm-label-block.disabled {
  background-color: #c2c2c2 !important;
  cursor: no-drop !important;
}
.xm-select > .xm-label .xm-label-block.disabled > i {
  cursor: no-drop !important;
}
.xm-select > .xm-body {
  position: absolute;
  left: 0;
  top: 42px;
  padding: 5px 0;
  z-index: 999;
  width: 100%;
  min-width: fit-content;
  border: 1px solid #e6e6e6;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12);
  animation-name: xm-upbit;
  animation-duration: 0.3s;
  animation-fill-mode: both;
}
.xm-select > .xm-body .scroll-body {
  overflow-x: hidden;
  overflow-y: auto;
}
.xm-select > .xm-body .scroll-body::-webkit-scrollbar {
  width: 8px;
}
.xm-select > .xm-body .scroll-body::-webkit-scrollbar-track {
  -webkit-border-radius: 2em;
  -moz-border-radius: 2em;
  -ms-border-radius: 2em;
  border-radius: 2em;
  background-color: #fff;
}
.xm-select > .xm-body .scroll-body::-webkit-scrollbar-thumb {
  -webkit-border-radius: 2em;
  -moz-border-radius: 2em;
  -ms-border-radius: 2em;
  border-radius: 2em;
  background-color: #c2c2c2;
}
.xm-select > .xm-body.up {
  top: auto;
  bottom: 42px;
}
.xm-select > .xm-body.relative {
  position: relative;
  display: block !important;
  top: 0;
  box-shadow: none;
  border: none;
  animation-name: none;
  animation-duration: 0;
  min-width: 100%;
}
.xm-select > .xm-body .xm-group {
  cursor: default;
}
.xm-select > .xm-body .xm-group-item {
  display: inline-block;
  cursor: pointer;
  padding: 0 10px;
  color: #999;
  font-size: 12px;
}
.xm-select > .xm-body .xm-option {
  display: flex;
  align-items: center;
  position: relative;
  padding: 0 10px;
  cursor: pointer;
}
.xm-select > .xm-body .xm-option-icon {
  color: transparent;
  display: flex;
  border: 1px solid #e6e6e6;
  border-radius: 3px;
  justify-content: center;
  align-items: center;
}
.xm-select > .xm-body .xm-option-icon.xm-custom-icon {
  color: unset;
  border: unset;
}
.xm-select > .xm-body .xm-option-icon-hidden {
  margin-right: -10px;
}
.xm-select > .xm-body .xm-option-icon.xm-icon-danx {
  border-radius: 100%;
}
.xm-select > .xm-body .xm-option-content {
  display: flex;
  position: relative;
  padding-left: 15px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: #666;
  width: calc(100% - 20px);
}
.xm-select > .xm-body .xm-option.hide-icon .xm-option-content {
  padding-left: 0;
}
.xm-select > .xm-body .xm-option.selected.hide-icon .xm-option-content {
  color: #fff !important;
}
.xm-select > .xm-body .xm-option .loader {
  width: 0.8em;
  height: 0.8em;
  margin-right: 6px;
  color: #c2c2c2;
}
.xm-select > .xm-body ..xm-select-empty {
  text-align: center;
  color: #999;
}
.xm-select > .xm-body .disabled {
  cursor: no-drop;
}
.xm-select > .xm-body .disabled:hover {
  background-color: #fff;
}
.xm-select > .xm-body .disabled .xm-option-icon {
  border-color: #c2c2c2 !important;
}
.xm-select > .xm-body .disabled .xm-option-content {
  color: #c2c2c2 !important;
}
.xm-select > .xm-body .disabled.selected > .xm-option-icon {
  color: #c2c2c2 !important;
}
.xm-select > .xm-body .xm-search {
  background-color: #fff !important;
  position: relative;
  padding: 0 10px;
  margin-bottom: 5px;
  cursor: pointer;
}
.xm-select > .xm-body .xm-search > i {
  position: absolute;
  color: #666;
}
.xm-select > .xm-body .xm-search-input {
  border: none;
  border-bottom: 1px solid #e6e6e6;
  padding-left: 27px;
  cursor: text;
}
.xm-select > .xm-body .xm-paging {
  padding: 0 10px;
  display: flex;
  margin-top: 5px;
}
.xm-select > .xm-body .xm-paging > span:first-child {
  border-radius: 2px 0 0 2px;
}
.xm-select > .xm-body .xm-paging > span:last-child {
  border-radius: 0 2px 2px 0;
}
.xm-select > .xm-body .xm-paging > span {
  display: flex;
  flex: auto;
  justify-content: center;
  vertical-align: middle;
  margin: 0 -1px 0 0;
  background-color: #fff;
  color: #333;
  font-size: 12px;
  border: 1px solid #e2e2e2;
  flex-wrap: nowrap;
  width: 100%;
  overflow: hidden;
  min-width: 50px;
}
.xm-select > .xm-body .xm-toolbar {
  padding: 0 10px;
  display: flex;
  margin: -3px 0;
  cursor: default;
}
.xm-select > .xm-body .xm-toolbar .toolbar-tag {
  cursor: pointer;
  display: flex;
  margin-right: 20px;
  color: #666;
  align-items: baseline;
}
.xm-select > .xm-body .xm-toolbar .toolbar-tag:hover {
  opacity: 0.8;
}
.xm-select > .xm-body .xm-toolbar .toolbar-tag:active {
  opacity: 1;
}
.xm-select > .xm-body .xm-toolbar .toolbar-tag > i {
  margin-right: 2px;
  font-size: 14px;
}
.xm-select > .xm-body .xm-toolbar .toolbar-tag:last-child {
  margin-right: 0;
}
.xm-select > .xm-body .xm-body-custom {
  line-height: initial;
  cursor: default;
}
.xm-select > .xm-body .xm-body-custom * {
  box-sizing: initial;
}
.xm-select > .xm-body .xm-tree {
  position: relative;
}
.xm-select > .xm-body .xm-tree-icon {
  display: inline-block;
  margin-right: 3px;
  cursor: pointer;
  border: 6px dashed transparent;
  border-left-color: #c2c2c2;
  border-left-style: solid;
  transition: all 0.3s;
  -webkit-transition: all 0.3s;
  z-index: 2;
  visibility: hidden;
}
.xm-select > .xm-body .xm-tree-icon.expand {
  margin-top: 3px;
  margin-right: 5px;
  margin-left: -2px;
  transform: rotate(90deg);
}
.xm-select > .xm-body .xm-tree-icon.xm-visible {
  visibility: visible;
}
.xm-select > .xm-body .xm-tree .left-line {
  position: absolute;
  left: 13px;
  width: 0;
  z-index: 1;
  border-left: 1px dotted #c0c4cc !important;
}
.xm-select > .xm-body .xm-tree .top-line {
  position: absolute;
  left: 13px;
  height: 0;
  z-index: 1;
  border-top: 1px dotted #c0c4cc !important;
}
.xm-select > .xm-body .xm-tree .xm-tree-icon + .top-line {
  margin-left: 1px;
}
.xm-select > .xm-body .scroll-body > .xm-tree > .xm-option > .top-line,
.xm-select > .xm-body .scroll-body > .xm-option > .top-line {
  width: 0 !important;
}
.xm-select > .xm-body .xm-cascader-box {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  padding: 5px 0;
  border: 1px solid #e6e6e6;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12);
  margin: -1px;
}
.xm-select > .xm-body .xm-cascader-box::before {
  content: ' ';
  position: absolute;
  width: 0;
  height: 0;
  border: 6px solid transparent;
  border-right-color: #e6e6e6;
  top: 10px;
  left: -12px;
}
.xm-select > .xm-body .xm-cascader-box::after {
  content: ' ';
  position: absolute;
  width: 0;
  height: 0;
  border: 6px solid transparent;
  border-right-color: #fff;
  top: 10px;
  left: -11px;
}
.xm-select > .xm-body .xm-cascader-scroll {
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
}
.xm-select > .xm-body.cascader {
  width: unset;
  min-width: unset;
}
.xm-select > .xm-body.cascader .xm-option-content {
  padding-left: 8px;
}
.xm-select > .xm-body.cascader .disabled .xm-right-arrow {
  color: #c2c2c2 !important;
}
.xm-select .xm-input {
  cursor: pointer;
  border-radius: 2px;
  border-width: 1px;
  border-style: solid;
  border-color: #e6e6e6;
  display: block;
  width: 100%;
  box-sizing: border-box;
  background-color: #fff;
  line-height: 1.3;
  padding-left: 10px;
  outline: 0;
  user-select: text;
  -ms-user-select: text;
  -moz-user-select: text;
  -webkit-user-select: text;
}
.xm-select .dis {
  display: none;
}
.xm-select .loading {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
}
.xm-select .loader {
  border: 0.2em dotted currentcolor;
  border-radius: 50%;
  -webkit-animation: 1s loader linear infinite;
  animation: 1s loader linear infinite;
  display: inline-block;
  width: 1em;
  height: 1em;
  color: inherit;
  vertical-align: middle;
  pointer-events: none;
}
.xm-select .xm-select-default {
  position: absolute;
  width: 100%;
  height: 100%;
  border: none;
  visibility: hidden;
}
.xm-select ..xm-select-disabled {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  cursor: no-drop;
  z-index: 2;
  opacity: 0.3;
  background-color: #fff;
}
.xm-select .item--divided {
  border-top: 1px solid #ebeef5;
  width: calc(100% - 20px);
  cursor: initial;
}
.xm-select .xm-right-arrow {
  position: absolute;
  color: #666;
  right: 5px;
  top: -1px;
  font-weight: 700;
  transform: scale(0.6, 1);
}
.xm-select .xm-right-arrow::after {
  content: '>';
}
.xm-select[size='large'] {
  min-height: 40px;
  line-height: 40px;
}
.xm-select[size='large'] .xm-input {
  height: 40px;
}
.xm-select[size='large'] .xm-label .scroll .label-content {
  line-height: 34px;
}
.xm-select[size='large'] .xm-label .xm-label-block {
  height: 30px;
  line-height: 30px;
}
.xm-select[size='large'] .xm-body .xm-option .xm-option-icon {
  height: 20px;
  width: 20px;
  font-size: 20px;
}
.xm-select[size='large'] .xm-paging > span {
  height: 34px;
  line-height: 34px;
}
.xm-select[size='large'] .xm-tree .left-line {
  height: 100%;
  bottom: 20px;
}
.xm-select[size='large'] .xm-tree .left-line-group {
  height: calc(100% - 40px);
}
.xm-select[size='large'] .xm-tree .xm-tree-icon.xm-hidden + .top-line {
  top: 19px;
}
.xm-select[size='large'] .item--divided {
  margin: 10px;
}
.xm-select {
  min-height: 36px;
  line-height: 36px;
}
.xm-select .xm-input {
  height: 36px;
}
.xm-select .xm-label .scroll .label-content {
  line-height: 30px;
}
.xm-select .xm-label .xm-label-block {
  height: 26px;
  line-height: 26px;
}
.xm-select .xm-body .xm-option .xm-option-icon {
  height: 18px;
  width: 18px;
  font-size: 18px;
}
.xm-select .xm-paging > span {
  height: 30px;
  line-height: 30px;
}
.xm-select .xm-tree .left-line {
  height: 100%;
  bottom: 18px;
}
.xm-select .xm-tree .left-line-group {
  height: calc(100% - 36px);
}
.xm-select .xm-tree .xm-tree-icon.xm-hidden + .top-line {
  top: 17px;
}
.xm-select .item--divided {
  margin: 9px;
}
.xm-select[size='small'] {
  min-height: 32px;
  line-height: 32px;
}
.xm-select[size='small'] .xm-input {
  height: 32px;
}
.xm-select[size='small'] .xm-label .scroll .label-content {
  line-height: 26px;
}
.xm-select[size='small'] .xm-label .xm-label-block {
  height: 22px;
  line-height: 22px;
}
.xm-select[size='small'] .xm-body .xm-option .xm-option-icon {
  height: 16px;
  width: 16px;
  font-size: 16px;
}
.xm-select[size='small'] .xm-paging > span {
  height: 26px;
  line-height: 26px;
}
.xm-select[size='small'] .xm-tree .left-line {
  height: 100%;
  bottom: 16px;
}
.xm-select[size='small'] .xm-tree .left-line-group {
  height: calc(100% - 32px);
}
.xm-select[size='small'] .xm-tree .xm-tree-icon.xm-hidden + .top-line {
  top: 15px;
}
.xm-select[size='small'] .item--divided {
  margin: 8px;
}
.xm-select[size='mini'] {
  min-height: 28px;
  line-height: 28px;
}
.xm-select[size='mini'] .xm-input {
  height: 28px;
}
.xm-select[size='mini'] .xm-label .scroll .label-content {
  line-height: 22px;
}
.xm-select[size='mini'] .xm-label .xm-label-block {
  height: 18px;
  line-height: 18px;
}
.xm-select[size='mini'] .xm-body .xm-option .xm-option-icon {
  height: 14px;
  width: 14px;
  font-size: 14px;
}
.xm-select[size='mini'] .xm-paging > span {
  height: 22px;
  line-height: 22px;
}
.xm-select[size='mini'] .xm-tree .left-line {
  height: 100%;
  bottom: 14px;
}
.xm-select[size='mini'] .xm-tree .left-line-group {
  height: calc(100% - 28px);
}
.xm-select[size='mini'] .xm-tree .xm-tree-icon.xm-hidden + .top-line {
  top: 13px;
}
.xm-select[size='mini'] .item--divided {
  margin: 7px;
}
.layui-form-pane .xm-select {
  margin: -1px -1px -1px 0;
}

.xm-select.layui-form-danger {
  border-color: #ff5722 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/common/LayuiTableSelect.vue